import React from "react";
import { formatScore } from "./scoreUtil";

export interface IProps {
  score: number
}

const Score: React.FunctionComponent<IProps> = (props) => {
  return <span style={{padding: "2px 6px 2px 6px"}} className="mr-8 rounded-4 bg-blue-50 text-16 leading-22 text-blue-600"><strong>{formatScore(props.score)}</strong></span>
};

export default Score;

